import { Provider } from "components/Process-status-foreign/ProcessStatusForeignContext";
import { ProcessStatusForeignList } from "components/Process-status-foreign/ProcessStatusForeignList";

export const ProcessStatusForeigns = () => {
    return (
        <Provider>
            <ProcessStatusForeignList />
        </Provider>
    );
};
